"use client";

import { PrimaryButton } from "@components/buttons";
import { DownloadButton, EmailButton, VisioButton } from "@components/buttons/littleButtons";
import { LeftArrowIcon, RightArrowIcon } from "@components/icons";
import { formatDateForList } from "@modules/formatValues";
import { useEffect, useRef, useState } from 'react';
import { CustomTooltip } from "@components/utilities";
import Link from "next/link";

// export function TabList({ dataList, className, prosId = "" }) {

//     const containerRef = useRef(null);
//     const [isOverflowing, setIsOverflowing] = useState(false);
//     const [showLeftArrow, setShowLeftArrow] = useState(false);
//     const [showRightArrow, setShowRightArrow] = useState(false);

//     useEffect(() => {
//         const checkOverflow = () => {
//             if (containerRef.current) {
//                 setIsOverflowing(containerRef.current.scrollWidth > containerRef.current.clientWidth);
//             }
//         };

//         const handleScroll = () => {
//             if (containerRef.current) {
//                 const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
//                 setShowLeftArrow(scrollLeft > 0);
//                 setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
//             }
//         }

//         checkOverflow();
//         handleScroll();
//         window.addEventListener('resize', checkOverflow);
//         window.addEventListener('resize', handleScroll);

//         const container = containerRef.current;

//         if (container) {
//             container.addEventListener('scroll', handleScroll);
//             handleScroll();
//         };

//         return () => {
//             window.removeEventListener('resize', checkOverflow);
//             window.removeEventListener('resize', handleScroll);
//             if (container) {
//                 container.removeEventListener('scroll', handleScroll);
//             }
//         };
//     }, []);

//     dataList.forEach(item => {
//         item.Date = formatDateForList(item.Date);
//     });

//     const handleScrollToStart = () => {
//         if (containerRef.current) {
//             containerRef.current.scrollTo({ left: 0, behavior: 'smooth' });
//             setShowLeftArrow(false);
//         }
//     };

//     const handleScrollToEnd = () => {
//         if (containerRef.current) {
//             containerRef.current.scrollTo({ left: containerRef.current.scrollWidth, behavior: 'smooth' });
//             setShowLeftArrow(true);
//         }
//     };

//     const categories = Object.keys(dataList[0]);

//     const categoriesElements = categories.map((category, index) => (
//         <li key={index} className="flex flex-1 items-center justify-center text-center font-bold">
//             {category}
//         </li>
//     ));

//     const listElements = dataList.map((item, index) => {
//         return (
//             <li key={index} className="flex items-center gap-x-2 border-b-1 border-b-slate-300">
//                 {categories.map((category, index) => (
//                     <span key={index} className="line-clamp-2 h-full flex-1 pb-2 text-center">
//                         {category === "PDF"
//                             ?
//                             <DownloadButton href={item[category]} className="size-3" />
//                             :
//                             category === "Lancer la visio" && item[category] && prosId
//                                 ?
//                                 <VisioButton href={`/rendez-vous/visio/${prosId}`} className="size-3" />
//                                 :
//                                 category === "Email"
//                                     ?
//                                     <EmailButton href={item[category]} className="size-3" />
//                                     :
//                                     item[category]
//                         }
//                     </span>
//                 ))}
//             </li>
//         )
//     });

//     const minTabWidth = 145 * categories.length;

//     return (
//         <div className={`mt-4 flex h-full max-h-96 max-w-full flex-col flex-wrap gap-y-20 overflow-x-auto lg:max-h-none ${className}`} ref={containerRef}>
//             <div style={{ minWidth: `${minTabWidth}px` }} className="mb-4 w-full flex-col px-4">
//                 <ul className="flex w-full border-b-2 border-b-slate-400 pb-2">
//                     {categoriesElements}
//                 </ul>
//                 <ul className="mt-4 flex w-full flex-col gap-y-2 !overflow-y-hidden">
//                     {listElements}
//                 </ul>
//             </div>
//             {isOverflowing && (
//                 <>
//                     {showLeftArrow && (
//                         <PrimaryButton
//                             className="absolute left-2 top-2/3 !size-9 min-h-0 min-w-0 -translate-y-1/2 rounded-full bg-white !p-2 shadow-md"
//                             onClick={handleScrollToStart}
//                         >
//                             <LeftArrowIcon className="size-4 stroke-primaryText stroke-2" />
//                         </PrimaryButton>
//                     )}
//                     {showRightArrow && (
//                         <PrimaryButton
//                             className="absolute right-2 top-2/3 !size-9 min-h-0 min-w-0 -translate-y-1/2 rounded-full bg-white !p-2 shadow-md"
//                             onClick={handleScrollToEnd}
//                         >
//                             <RightArrowIcon className="size-4 stroke-primaryText stroke-2" />
//                         </PrimaryButton>
//                     )}
//                 </>
//             )}
//         </div>
//     );
// }


export function TabList({ dataList, className, prosId = "" }) {

    const containerRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (containerRef.current) {
                setIsOverflowing(containerRef.current.scrollWidth > containerRef.current.clientWidth);
            }
        };

        const handleScroll = () => {
            if (containerRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
                setShowLeftArrow(scrollLeft > 0);
                setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
            }
        }

        checkOverflow();
        handleScroll();
        window.addEventListener('resize', checkOverflow);
        window.addEventListener('resize', handleScroll);

        const container = containerRef.current;

        if (container) {
            container.addEventListener('scroll', handleScroll);
            handleScroll();
        };

        return () => {
            window.removeEventListener('resize', checkOverflow);
            window.removeEventListener('resize', handleScroll);
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    dataList.forEach(item => {
        item.Date = formatDateForList(item.Date);
    });

    const handleScrollToStart = () => {
        if (containerRef.current) {
            containerRef.current.scrollTo({ left: 0, behavior: 'smooth' });
            setShowLeftArrow(false);
        }
    };

    const handleScrollToEnd = () => {
        if (containerRef.current) {
            containerRef.current.scrollTo({ left: containerRef.current.scrollWidth, behavior: 'smooth' });
            setShowLeftArrow(true);
        }
    };

    const categories = Object.keys(dataList[0]);

    const categoriesElements = categories.map((category, index) => (
        <li key={index} className="flex flex-1 items-center justify-center text-center font-bold">
            {category}
        </li>
    ));

    const listElements = dataList.map((item, index) => {
        return (
            <li key={index} className="flex items-center gap-x-2 border-b-1 border-b-slate-300">
                {categories.map((category, index) => (
                    <span key={index} className="line-clamp-2 h-full flex-1 pb-2 text-center">
                        {category === "PDF"
                            ?
                            <DownloadButton href={item[category]} className="size-3" />
                            :
                            category === "Lancer la visio" && item[category] && prosId
                                ?
                                <CustomTooltip content="Acceder à la visio">
                                    <VisioButton href={`/rendez-vous/visio/${prosId}`} className="size-3" />
                                </CustomTooltip>

                                :
                                category === "Mail"
                                    ?

                                    
                                        <EmailButton href={`mailto:${item[category]}`} className="size-3" />
                                 



                                    :
                                    item[category]
                        }
                    </span>
                ))}
            </li>
        )
    });

    const minTabWidth = 145 * categories.length;

    return (
        <div className={`mt-4 flex h-full max-h-96 max-w-full flex-col flex-wrap gap-y-20 overflow-x-auto lg:max-h-none ${className}`} ref={containerRef}>
            <div style={{ minWidth: `${minTabWidth}px` }} className="mb-4 w-full flex-col px-4">
                <ul className="flex w-full border-b-2 border-b-slate-400 pb-2">
                    {categoriesElements}
                </ul>
                {/* Conteneur de la liste avec un overflow vertical limité */}
                <ul className="mt-4 flex w-full flex-col gap-y-2 overflow-y-auto max-h-60"> {/* max-h-60 limite la hauteur */}
                    {listElements}
                </ul>
            </div>
            {isOverflowing && (
                <>
                    {showLeftArrow && (
                        <PrimaryButton
                            className="absolute left-2 top-2/3 !size-9 min-h-0 min-w-0 -translate-y-1/2 rounded-full bg-white !p-2 shadow-md"
                            onClick={handleScrollToStart}
                        >
                            <LeftArrowIcon className="size-4 stroke-primaryText stroke-2" />
                        </PrimaryButton>
                    )}
                    {showRightArrow && (
                        <PrimaryButton
                            className="absolute right-2 top-2/3 !size-9 min-h-0 min-w-0 -translate-y-1/2 rounded-full bg-white !p-2 shadow-md"
                            onClick={handleScrollToEnd}
                        >
                            <RightArrowIcon className="size-4 stroke-primaryText stroke-2" />
                        </PrimaryButton>
                    )}
                </>
            )}
        </div>
    );
}